import DocumentTypes from '../config/documentTypes';

const i18nHelper = {
  
  BRAZIL_ID: 31,

  getDocumentTypeOptions: (countryId, t) => {
    if (countryId === i18nHelper.BRAZIL_ID) {
      return [
        { value: DocumentTypes.CPF, label: 'CPF' },
        { value: DocumentTypes.CNPJ, label: 'CNPJ' }
      ];
    }
    return [
      { value: DocumentTypes.PASSPORT, label: t('passport') },
    ];
  },
};

export default i18nHelper;
